import {ApiClient} from '@hconnect/apiclient'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import type {MaterialStorage, MaterialStorageDTO} from '../types'

const keyToResourceMap: Record<
  keyof MaterialStorageDTO,
  | 'name'
  | 'capacity'
  | 'dead-stock'
  | 'material'
  | 'is-optimized'
  | 'is-measured'
  | 'minimum-stock-level'
  | 'minimum-weekend-stock-level'
  | 'material-type'
  | 'measurement-type'
  | 'upm-id'
> = {
  name: 'name',
  capacity: 'capacity',
  deadStock: 'dead-stock',
  materialId: 'material',
  isOptimized: 'is-optimized',
  isMeasured: 'is-measured',
  minimumStockLevel: 'minimum-stock-level',
  minimumWeekendStockLevel: 'minimum-weekend-stock-level',
  materialType: 'material-type',
  measurementType: 'measurement-type',
  upmId: 'upm-id'
}

type Variables = {
  plantCode: string
  id: number
  key: keyof MaterialStorageDTO
  dto: Partial<MaterialStorageDTO>
}

export const useEditMaterialStorage = ({
  onError,
  onSuccess
}: {
  onError?: (error: AxiosError, variables: Variables) => void
  onSuccess?: (data: MaterialStorage, variables: Variables) => void
} = {}) =>
  useMutation<MaterialStorage, AxiosError, Variables>({
    mutationFn: async ({plantCode, id, key, dto}) => {
      const response = await ApiClient.axiosInstance.patch<MaterialStorage>(
        `/plants/${plantCode}/material-storage/${id}/${keyToResourceMap[key]}`,
        dto
      )
      return response.data
    },
    onError,
    onSuccess
  })
